import { PlayerAdapterPerformanceMode } from 'library/ts/player/adapter/enums/PlayerAdapterPerformanceMode';
import { IParamsVO } from 'tag/ts/tag/interfaces/params/IParamsVO';
import { EmbedDevice } from 'tag/ts/tag/model/type/embed/EmbedDevice';
import { AbstractSTVPlatformConfig } from 'tag/ts/tag/player/stv/configs/platforms/AbstractSTVPlatformConfig';

export class TCL extends AbstractSTVPlatformConfig {

	constructor( params: IParamsVO ) {
		super( params );
		this.configs = this.utils.DeepMerge.deepmerge( this.configs, {
			properties: {
				device: EmbedDevice.TCL
			},
			playerOptions: {
				performanceMode: PlayerAdapterPerformanceMode.LOW
			}
		} );
	}

}